import { mapGetters } from 'vuex'
import i18n from '@/locales'

export default {
  computed: mapGetters(['isAdminMode']),
  created () {
    this.singleActions = [
      {
        label: i18n.t('meter.confirm_suggest'),
        permission: 'suggestsysalerts_perform_confirm',
        action: (obj) => {
          this.createDialog('BatchIgnoreDialog', {
            type: 'confirm',
            vm: this,
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            refresh: this.refresh,
            success: () => {
              this.destroySidePage(this.windowId)
            },
          })
        },
        meta: (obj) => {
          return {
            validate: obj.status === 'ready',
          }
        },
      },
      {
        label: i18n.t('bill.text_268'),
        permission: 'suggestsysalerts_perform_ignore',
        action: (obj) => {
          this.createDialog('BatchIgnoreDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            refresh: this.refresh,
            success: () => {
              this.destroySidePage(this.windowId)
            },
          })
        },
        meta: (obj) => {
          return {
            validate: true,
          }
        },
      },
    ]
  },
}
